import { IconSizeType } from '../../interfaces/Element.interfaces';

export const getIconWidthHeight = (
  size: IconSizeType
): { width: number; height: number } => {
  switch (size) {
    case 'XLarge':
      return { width: 24, height: 24 };
    case 'Large':
      return { width: 20, height: 20 };
    case 'Medium':
      return { width: 14, height: 14 };
    case 'Small':
      return { width: 10, height: 10 };
    default:
      return { width: 10, height: 10 };
  }
};
